export default __webpack_public_path__ + "static/gradient-1330d417e4827bc7d16b0cc628df7e39.png";